<template>
    <span>
        <slot v-if="!confirming && !deleting"></slot>
        <a href @click.prevent="onClick" :disabled="deleting" class="bad-bg" :class="classes">{{ content }}<span class="fa" :class="buttonIcon"></span></a>
        <a v-if="confirming && !deleting" href @click.prevent="confirming = false" class="neutral-bg">Cancel <span class="fa fa fa-times-circle"></span></a>
    </span>
</template>

<script>

export default {

    props: {
        icon: {
            type: String,
            default: 'fa-trash',
        },

        text: {
            type: String,
            default: 'Delete',
        },

        confirmText: {
            type: String,
            default: 'Confirm Delete',
        },

        deletingText: {
            type: String,
            default: 'Deleting...',
        },

        href: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            confirming: false,
            deleting: false,
        }
    },

    computed: {
        classes() {
            if (this.confirming) return 'confirm';

            return '';
        },

        content() {
            let content = this.text;
            if (this.confirming) {
                content = this.confirmText;
            }

            if (this.deleting) {
                content = this.deletingText;
            }

            return content;
        },

        buttonIcon() {
            if (this.deleting) {
                return 'fa-spinner fa-spin';
            }

            return this.icon;
        }

    },

    methods: {

        onClick() {
            if (this.deleting) return;

            if (!this.confirming) {
                this.confirming = true;
                return;
            }

            this.deleting = true;
            if (this.href) {
                window.location.href = this.href;
            }
            this.$emit('deleted', () => {
                this.deleting = false;
            });
            setTimeout(() => {
                this.deleting = false;
            }, 5000);
        }
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/DeleteButton.vue